export const PAGE_SIZES = [25, 50, 100]